import React from "react";
import { Routes, Route } from 'react-router-dom';

import AdminDashboard from './../Pages/Admin/Dashboard';

import AdminUsers from './../Pages/Admin/Users/Users';
import AdminUserAdd from './../Pages/Admin/Users/UserAdd';
import AdminUserEdit from './../Pages/Admin/Users/UserEdit';

import AdminCampaigns from './../Pages/Admin/Campaigns/Campaign';
import AdminCampaignAdd from './../Pages/Admin/Campaigns/CampaignAdd';
import AdminCampaignEdit from './../Pages/Admin/Campaigns/CampaignEdit';
import AdminCampaignReport from './../Pages/Admin/Campaigns/CampaignReport';

import AdminLeads from './../Pages/Admin/Leads/Lead';
import AdminLeadEdit from './../Pages/Admin/Leads/EditLead';

import AdminActivityLogs from './../Pages/Admin/ActivityLogs';

import AdminNotifications from './../Pages/Admin/Notifications/Notification';

import AdminSettingState from './../Pages/Admin/Setting/State/State';

import AdminSettingCity from './../Pages/Admin/Setting/City/City';

import AdminSettingDisposition from './../Pages/Admin/Setting/Disposition/Disposition';

import AdminSettingSubdisposition from './../Pages/Admin/Setting/Subdisposition/Subdisposition';

import AdminSettingCollege from './../Pages/Admin/Setting/College/College';

import AdminUploadLeads from './../Pages/Admin/Leads/UploadLeads';

import AdminTrackUsers from './../Pages/Admin/UserTrack';

//import AuthChecker from './../Pages/AuthenticationChecker';

//import NotFound from './../Pages/NotFound';

const Admin = [
    {
        path: "admin/dashboard",
        element: <AdminDashboard />,
    },
    {
        path: "admin/campaign-report/:campaignid",
        element: <AdminCampaignReport />,
    },
    {
        path: "admin/users",
        element: <AdminUsers />,
    },
    {
        path: "admin/user/add",
        element: <AdminUserAdd />,
    },
    {
        path: "admin/user/:userid/edit",
        element: <AdminUserEdit />,
    },
    {
        path: "admin/campaigns",
        element: <AdminCampaigns />,
    },
    {
        path: "admin/campaign/add",
        element: <AdminCampaignAdd />,
    },
    {
        path: "admin/campaign/:campaignid/edit",
        element: <AdminCampaignEdit />,
    },
    {
        path: "admin/leads",
        element: <AdminLeads />,
    },
    {
        path: "admin/lead/:leadid/edit",
        element: <AdminLeadEdit />,
    },
    {
        path: "admin/activity-logs",
        element: <AdminActivityLogs />,
    },
    {
        path: "admin/notifications",
        element: <AdminNotifications />,
    },
    {
        path: "admin/setting/state",
        element: <AdminSettingState />,
    },
    {
        path: "admin/setting/city",
        element: <AdminSettingCity />,
    },
    {
        path: "admin/setting/dispositions",
        element: <AdminSettingDisposition />,
    },
    {
        path: "admin/setting/subdisposition",
        element: <AdminSettingSubdisposition />,
    },
    {
        path: "admin/setting/colleges",
        element: <AdminSettingCollege />,
    },
    {
        path: "admin/upload-lead",
        element: <AdminUploadLeads />,
    },
    {
        path: "admin/track-users",
        element: <AdminTrackUsers />,
    }
];

/*const Admin = () =>{

    return(
    <Routes>
        <Route element={<AuthChecker />}>
            <Route path="admin/dashboard" element={<AdminDashboard />} />
            <Route path="admin/users" element={<AdminUsers />} />
            <Route path="admin/user/add" element={<AdminUserAdd />} />
            <Route path="admin/user/:userid/edit" element={<AdminUserEdit />} />

            <Route path="admin/campaigns" element={<AdminCampaigns />} />
            <Route path="admin/campaign/add" element={<AdminCampaignAdd />} />
            <Route path="admin/campaign/:campaignid/edit" element={<AdminCampaignEdit />} />

            <Route path="admin/leads" element={<AdminLeads />} />
            <Route path="admin/lead/:leadid/edit" element={<AdminLeadEdit />} />

            <Route path="admin/activity-logs" element={<AdminActivityLogs />} />

            <Route path="admin/notifications" element={<AdminNotifications />} />

            <Route path="admin/setting/state" element={<AdminSettingState />} />
            <Route path="admin/setting/city" element={<AdminSettingCity />} />
            <Route path="admin/setting/dispositions" element={<AdminSettingDisposition />} />
            <Route path="admin/setting/subdisposition" element={<AdminSettingSubdisposition />} />
            <Route path="admin/setting/colleges" element={<AdminSettingCollege />} />

            <Route path="*" element={<NotFound />} />
        </Route>
    </Routes>
    );
}*/

export default Admin;